import {useState} from 'preact/hooks'
import {DestinationSearchV2} from './DestinationSearchV2'
import {TravelDateSelector} from './TravelDateSelector'
import {IconCalendar} from './svg-icons/IconCalendar'
import '../styles/components/SearchWidget.css'
import {
    ExtIdItem,
    FilterOptions,
    KuratierteReiseItem,
    SearchFilters,
    SearchRedirect,
    UpdateFilterItem
} from "../types/travel.ts";

interface SearchWidgetProps {
    filterOptions: FilterOptions
    filters: SearchFilters
    onFiltersChange: (filters: SearchFilters) => void
    gridViewState: boolean
    setGridViewState: (value: boolean) => void
    kuratierteReisen?: KuratierteReiseItem[]
    extIdItems?: ExtIdItem[]
    searchRedirects? : SearchRedirect[]
}

export function SearchWidget({
                                 filterOptions,
                                 filters,
                                 onFiltersChange,
                                 gridViewState,
                                 setGridViewState,
                                 kuratierteReisen,
                                 extIdItems,
                                 searchRedirects
}: SearchWidgetProps) {
    const [calendarButtonDisabled, setCalendarButtonDisabled] = useState(false);
    const [destinationInputTerm, setDestinationInputTerm] = useState('');

    const updateFilterArray = (category: keyof SearchFilters, values: string[]) => {
        onFiltersChange({
            ...filters,
            [category]: values
        })
    }

    const updateMultiFilterArray = (updateFilterItems: UpdateFilterItem[]) => {
        const updatedFilters = { ...filters };

        updateFilterItems.forEach(({ category, values }) => {
            if (category === 'start' || category === 'end') {
                // These fields expect string, not string[]
                updatedFilters[category] = Array.isArray(values) ? values[0] : values;
            } else {
                // Other fields expect string[]
                updatedFilters[category] = Array.isArray(values) ? values : [values];
            }
        });

        onFiltersChange(updatedFilters);
    }

    const handleSearchClick = (target = '') => {
        // Build query string from current filters
        const params = new URLSearchParams()

        const effectiveFilters = { ...filters }
        if ((!effectiveFilters.destination || effectiveFilters.destination.length === 0) && destinationInputTerm) {
            effectiveFilters.destination = [destinationInputTerm]
        }

        Object.entries(effectiveFilters).forEach(([key, values]) => {
            if (values && Array.isArray(values) && values.length > 0) {
                params.set(key, values.join(','))
            } else {
                params.set(key, typeof values === "string" ? values : values.join(','))
            }
        })

        if(target === 'calendar') {
            params.set('termine', 'true');
        }

        // Build and redirect to the search page
        const queryString = params.toString()
        window.location.href = queryString
            ? `/suche/?${queryString}`
            : '/suche/'
    }

    return (
        <div className="
                search-widget
                bg-white
                lg:rounded-20px
                {/*lg:shadow-lg*/}
                px-7 lg:px-6
                pt-[38px] lg:pt-6
                pb-8 lg:pb-6
                 w-full max-w-[1162px]
                border-b border-theme-gray border-solid lg:border-0
                ">
            <div className="flex flex-col lg:flex-row gap-4 items-center">

                {/* Destination Search Field */}
                <div className="flex-1 w-full lg:w-auto">
                    <DestinationSearchV2
                        options={filterOptions.destination}
                        selectedValues={filters.destination || []}
                        kuratierteReisen={kuratierteReisen || []}
                        onSelectionChange={(values) => {
                            onFiltersChange({
                                ...filters,
                                destination: values
                            })
                        }}
                        isSearchWidget={true}
                        extIdItems={extIdItems}
                        onTriggerWidgetSearchClick={handleSearchClick}
                        onSearchTermChange={setDestinationInputTerm}
                        searchRedirects={searchRedirects}
                    />
                </div>

                {/* Date Selector Field */}
                <div className="flex-1 w-full lg:w-auto">
                    <TravelDateSelector
                        options={filterOptions.yearmonth || []}
                        selectedValues={filters.yearmonth || []}
                        onSelectionChange={updateFilterArray}
                        onDateSelection={updateMultiFilterArray}
                        gridViewState={gridViewState}
                        setGridViewState={setGridViewState}
                        initialStart={filters.start}
                        initialEnd={filters.end}
                    />
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
                    {/* Search Button */}
                    <button
                        onClick={() => handleSearchClick()}
                        className="btn red w-full mobile-prevent-btn-hover">
                        Reise finden
                    </button>

                    {/* Calendar Button */}
                    <button
                        onClick={() => {
                            setCalendarButtonDisabled(true)
                            handleSearchClick('calendar')
                        }}
                        className="btn ghost red cursor-pointer"
                        disabled={calendarButtonDisabled}
                    >
                        <IconCalendar cssClasses="w-5 h-5"/>
                        Kalender
                    </button>
                </div>

            </div>
        </div>
    )
}
